// TEXTUROART marketing windows, recurring annually in America/New_York.
// These are store campaign periods, not official holiday durations.
// Copy only: checkout discounts and shipping rules remain managed by Shopify.
const DAY = 86400000;
const date = (year, month, day) => Date.UTC(year, month - 1, day);
const weekday = (year, month, dayOfWeek, occurrence) => {
  const first = date(year, month, 1);
  return first + ((dayOfWeek - new Date(first).getUTCDay() + 7) % 7 + (occurrence - 1) * 7) * DAY;
};

export function campaignWindows(year) {
  const thanksgiving = weekday(year, 11, 4, 4);
  const blackFriday = thanksgiving + DAY;
  const cyberMonday = thanksgiving + 4 * DAY;
  const presidentsDay = weekday(year, 2, 1, 3);
  const lastMayDay = date(year, 5, 31);
  const memorialDay = lastMayDay - ((new Date(lastMayDay).getUTCDay() + 6) % 7) * DAY;
  const laborDay = weekday(year, 9, 1, 1);
  return [
    { name: 'NEW YEAR SALE', start: date(year, 1, 1), end: date(year, 1, 5) },
    { name: "VALENTINE'S DAY SALE", start: date(year, 2, 7), end: date(year, 2, 14) },
    { name: "PRESIDENTS' DAY SALE", start: Math.max(presidentsDay - 3 * DAY, date(year, 2, 15)), end: presidentsDay },
    { name: 'MEMORIAL DAY SALE', start: memorialDay - 3 * DAY, end: memorialDay },
    { name: '4TH OF JULY SALE', start: date(year, 6, 28), end: date(year, 7, 4) },
    { name: 'LABOR DAY SALE', start: laborDay - 3 * DAY, end: laborDay },
    { name: 'HALLOWEEN SALE', start: date(year, 10, 24), end: date(year, 10, 31) },
    { name: 'BLACK FRIDAY SALE', start: blackFriday - 7 * DAY, end: cyberMonday - DAY },
    { name: 'CYBER MONDAY SALE', start: cyberMonday, end: cyberMonday + 2 * DAY },
    { name: 'CHRISTMAS SALE', start: cyberMonday + 3 * DAY, end: date(year, 12, 25) },
    { name: 'NEW YEAR SALE', start: date(year, 12, 26), end: date(year, 12, 31) }
  ];
}

const easternDate = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric'
});

export function campaignName(now = new Date()) {
  const parts = Object.fromEntries(easternDate.formatToParts(now).map(part => [part.type, part.value]));
  const year = Number(parts.year);
  const today = date(year, Number(parts.month), Number(parts.day));
  return campaignWindows(year).find(window => today >= window.start && today <= window.end)?.name || '';
}

export function campaignText(now = new Date(), baseText = '45% OFF SITEWIDE') {
  const name = campaignName(now);
  return name ? `${name} — ${baseText}` : baseText;
}

if (typeof window !== 'undefined' && !customElements.get('texturoart-seasonal-promo')) {
  const active = new Set();
  class SeasonalPromo extends HTMLElement {
    connectedCallback() {
      this.baseText = this.getAttribute('data-base-text') || this.textContent.trim();
      active.add(this);
      this.refresh();
    }
    disconnectedCallback() { active.delete(this); }
    refresh() {
      const text = campaignText(new Date(), this.baseText);
      if (this.textContent !== text) this.textContent = text;
    }
  }
  customElements.define('texturoart-seasonal-promo', SeasonalPromo);
  const refresh = () => active.forEach(element => element.refresh());
  // Also switch on already-open pages, within a minute of Eastern midnight.
  window.setInterval(refresh, 60000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', refresh);
}
